var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWidgetTitle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 206,
    height: 177,
    viewBox: "0 0 206 177",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M178.376 105.491C164.789 142.102 153.365 174.175 112.774 166.947C91.4276 163.147 46.5838 145.33 26.6583 119.089C4.1923 100.452 15.123 68.9457 18.4379 50.7998C25.4298 12.5257 71.0752 14.7282 111.666 21.9556C152.257 29.183 185.368 67.2167 178.376 105.491Z",
    fill: "#F5F5F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3608 73.2388C52.164 92.5123 53.7561 104.584 57.0572 120.9C58.0245 125.69 59.6045 131.13 64.0704 133.121C66.5597 134.236 69.424 133.987 72.1325 133.72C86.6928 132.291 101.248 130.876 115.808 129.447C122.972 128.745 130.233 128.023 136.962 125.465C146.167 121.967 154.459 114.131 155.335 104.324C155.665 100.655 154.953 96.9932 154.251 93.3801C152.056 82.1339 149.867 70.875 147.677 59.6161C147.319 57.7916 146.937 55.9133 145.897 54.3767C143.441 50.7649 138.356 50.335 133.99 50.4046C109.866 50.8333 86.1173 55.9751 62.5526 61.1026C59.3281 61.7993 55.9908 62.5542 53.3756 64.568C50.7604 66.5817 50.1441 69.1246 50.3608 73.2388Z",
    stroke: "#3D3935",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50.6307 68.4753C59.1636 80.4671 73.5674 91.648 89.7842 98.2163C94.5035 100.132 100.259 102.35 104.752 101.603C111.171 100.54 115.72 96.3245 120.703 92.1373C132.033 82.6372 140.19 72.0576 147.129 58.9921",
    stroke: "#3D3935",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7306 130.285C73.0774 122.426 86.1384 110.271 96.187 100.816",
    stroke: "#3D3935",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M112.763 98.155C119.186 100.926 125.98 103.55 131.819 105.891C138.735 108.654 144.253 111.458 150.637 114.213",
    stroke: "#3D3935",
    strokeWidth: 4,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M201.984 46.8541C193.445 61.5681 169.005 74.7365 154.215 66.2414C139.424 57.7463 135.436 31.4784 143.975 16.7644C152.515 2.05049 174.824 12.1313 189.614 20.6264C204.404 29.1215 210.523 32.1402 201.984 46.8541Z",
    fill: "#EF533F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M178.981 26.9134C175.085 28.358 162.664 31.7977 157.299 34.6746C159.271 35.3072 172.327 50.0178 173.592 50.2634C174.856 50.5091 175.547 46.5072 175.915 43.5771C176.283 40.6471 183.851 25.1077 178.981 26.9134Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M179.835 27.8291C176.505 30.7874 169.374 37.2461 167.487 39.4145C165.601 41.5828 162.833 45.0552 161.684 46.5204L169.832 47.1435",
    stroke: "white",
    strokeWidth: 4,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWidgetTitle);
export default __webpack_public_path__ + "static/media/widget-title.e146e8ed678db63486a8e83a9044584e.svg";
export { ForwardRef as ReactComponent };